import React, { useEffect, useRef } from 'react';
import "./style.scss"
import { Link, useNavigate } from 'react-router-dom';
import { Formatter } from 'utils/formatter';
import { FaRegHeart } from 'react-icons/fa';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Button } from '@mui/material';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

import { Discount } from 'utils/discount';
import { PacmanLoader } from 'react-spinners';

const BookSection = ({title, books, type}) => {
    const cardRefs = useRef([]);

    useEffect(() => {
      const cards = cardRefs.current;
      let maxHeight = 0;
  
      // Tính chiều cao lớn nhất
      cards.forEach((card) => {
        if (card) {
          maxHeight = Math.max(maxHeight, card.offsetHeight);
        }
      });
  
      // Gán chiều cao lớn nhất cho tất cả các card
      cards.forEach((card) => {
        if (card) {
          card.style.height = `${maxHeight}px`;
        }
      });
    }, [books]);
    const navigate = useNavigate();
    return (
        <>
            <div className="container">
                <div className="title">
                    <h3>{title}</h3>
                    <Link to={`/books?type=${type}`} state={{ book: books }} style={{color: "#5e2e86"}}>Xem tất cả</Link>
                </div>

                <div className="product_row w-100">
                <Swiper
                    slidesPerView={6} 
                    spaceBetween={10} 
                    navigation={true}
                    pagination = {{ clickable: true }}
                    modules={[Navigation]} 
                    className="mySwiper"
                    breakpoints={{
                        360: {
                            slidesPerView: 2, // Từ 768px đến 992px hiển thị 4 slides
                            spaceBetween: 10
                        },
                        768: {
                            slidesPerView: 4, // Từ 768px đến 992px hiển thị 4 slides
                            spaceBetween: 10
                        },
                        993: {
                            slidesPerView: 6, // Từ 992px trở lên hiển thị 6 slides
                            spaceBetween: 10
                        }
                    }}
                >

                    {books && Array.isArray(books) && books.length > 0 ? (
                        books.map((book, index) => (
                            <SwiperSlide key={book.id} onClick={() => navigate(`/details/${book.slug}`)}>
                                <div className=" productItem"
                                ref={(el) => (cardRefs.current[index] = el)}>
                                    <div className="imgWrapper">
                                        <img src={book.imageLink} alt={book.title} className='w-100' />
                                        { book.originalPrice !== book.discountedPrice ? (
                                            <span className="badge bg-danger">- {Discount(book.originalPrice, book.discountedPrice)}%</span>
                                        ) : (
                                            <span></span>
                                        )}
                                        
                                        <div className='actions'>
                                            <Button
                                                onClick={(e) => { e.stopPropagation();}}>
                                                <FaRegHeart />
                                            </Button>
                                        </div>
                                        <h4>{book.title}</h4>
                                        <span  className={book.availableQuantity > 0 ? 'inStock' : 'outOfStock'}>
                                            {book.availableQuantity > 0 ? 'Còn hàng' : 'Hết hàng'}
                                        </span>
                                        <div className="d-flex justify-content-between mt-1">
                                            <span className="curPrice text-danger">{Formatter(book.discountedPrice)}</span>
                                            <span className="oriPrice">{Formatter(book.originalPrice)}</span>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))
                    ) : (
                        <PacmanLoader color="#5E2E86" />
                    )}
                </Swiper>
                </div>
            </div>
        </>
    )
}

export default BookSection;